import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import './AccessStatus.css';

// Full-page messages shown in place of a route's content, using the app's existing
// warning box styles (warning-wrap / alert-msg-box).
function AccessStatus({ title, message, actionLabel, onAction }) {
  return (
    <section className="access-status">
      <div className="warning-wrap alert-msg-box" role="alert">
        <span className="icon warning-icon"><AlertTriangle /></span>
        {title && <span className="alert-title">{title}</span>}
        <span className='alert-title'>{message}</span>
        {actionLabel && onAction && (
          <button type="button" className="btn btn-primary access-status__btn" onClick={onAction}>{actionLabel}</button>
        )}
      </div>
    </section>
  );
}

export function AccessDenied() {
  return <AccessStatus message="You don't have permission to view this page." />;
}

// homePath is the first page the user may open; null when they may open none.
export function NotFound({ homePath }) {
  const navigate = useNavigate();
  return (
    <AccessStatus
      title="Page Not Found"
      message="The page you are looking for doesn't exist."
      actionLabel={homePath ? 'Go to Home' : null}
      onAction={() => navigate(homePath)}
    />
  );
}

export function PermissionsUnavailable({ onRetry }) {
  return (
    <AccessStatus
      title="Access could not be verified"
      message="We couldn't load your permissions. Please try again."
      actionLabel="Retry"
      onAction={onRetry}
    />
  );
}
